<template>
  <v-dialog v-model="internal" max-width="600" overlay-opacity="0.59" transition="dialog-bottom-transition">
    <v-card outlined>
      <div class="d-flex align-center justify-space-between mx-5">
        <v-card-title class="operation-created__title mt-0 py-3">
          <span class="pt-3">{{ $t('instructions.operationCreatedModalTitle') }}</span>
        </v-card-title>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-card-text class="my-2">
        <v-card v-if="operation" class="px-5 pt-4 pb-6" outlined elevation="0">
          <h2 class="operation-created__id my-1">ID:{{ operationId }}</h2>
          <v-divider />
          <v-card-text class="operation-created__info">
            <div v-for="item in infoRows" :key="item.key" class="operation-created__row">
              <h4>{{ item.label }}</h4>
              <h2>{{ item.value }}</h2>
            </div>
          </v-card-text>
        </v-card>

        <div class="d-flex justify-space-between mt-4 flex-wrap button-gap">
          <v-btn outlined @click="close">{{ $t('instructions.close') }}</v-btn>
          <v-btn color="primary" @click="goToOperations">{{ $t('instructions.goToOperations') }}</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { getTimeZone } from '@/utils'

export default {
  name: 'OperationCreatedModal',
  props: {
    value: { type: Boolean, default: false },
    operation: { type: Object, default: null }
  },
  computed: {
    internal: {
      get () { return this.value },
      set (value) { this.$emit('input', value) }
    },
    operationName () {
      return this.operation?.alias || '-'
    },
    operationId () {
      return this.operation?.id || '-'
    },
    bankName () {
      return this.operation?.bankName ||
        this.operation?.bank_name ||
        this.operation?.bankLabel ||
        this.operation?.bank_label ||
        this.operation?.bank?.name ||
        '-'
    },
    operationPurpose () {
      const purpose = this.operation?.operationType
      return purpose ? (this.$t('broker.operationTypes')[purpose] || purpose) : '-'
    },
    createdAt () {
      const value = this.operation?.timecreate
      if (!value) return '-'
      const numericValue = Number(value)
      const normalizedValue = Number.isFinite(numericValue)
        ? (numericValue > 1e12 ? numericValue : numericValue * 1000)
        : (typeof value === 'string' ? value.replace(' ', 'T') : value)
      const date = new Date(normalizedValue)
      if (Number.isNaN(date.getTime())) return String(value)
      return new Intl.DateTimeFormat(this.$i18n.locale, {
        dateStyle: 'medium',
        timeStyle: 'short',
        timeZone: getTimeZone()
      }).format(date)
    },
    documentCount () {
      return Number(this.operation?.length) || 0
    },
    infoRows () {
      return [
        { key: 'bank', label: this.$t('quoteInfo.bankName'), value: this.bankName },
        { key: 'name', label: this.$t('instructions.operationName'), value: this.operationName },
        { key: 'purpose', label: this.$t('broker.labels.transactionPurpose'), value: this.operationPurpose },
        { key: 'created', label: this.$t('instructions.operationCreatedAt'), value: this.createdAt },
        { key: 'documents', label: this.$t('instructions.operationDocuments'), value: this.documentCount }
      ]
    }
  },
  methods: {
    close () {
      this.$emit('input', false)
    },
    goToOperations () {
      this.close()
      if (this.$route.name === 'operations') return
      this.$router.push({ name: 'operations' }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.button-gap { gap: 12px; }

.operation-created__title {
  font-size: 1rem;
  line-height: 1rem;
  letter-spacing: .1rem;
  text-transform: uppercase;
}

.operation-created__id {
  overflow-wrap: anywhere;
}

.operation-created__info {
  display: flex;
  flex-direction: column;
  gap: 1.4rem;
  padding-top: 1.25rem;
}

.operation-created__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 1.5rem;
}

.operation-created__row h2 {
  max-width: 65%;
  text-align: right;
  overflow-wrap: anywhere;
}

@media (max-width: 480px) {
  .operation-created__row h2 {
    font-size: 1.15rem;
  }
}
</style>
